import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import { TABLE_FLASH_SALE, FILTER_GIFT } from 'configs/flash-sale/configTableFlashSaleList'
import Search from 'components/commons/search'
import Filter from 'components/commons/filter'

export const FlashSaleList = ({
    dataList,
    query,
    queryFilter,
    onChangeQuery,
    onDelete,
    onClickItemHandler,
    onFilter,
    modal,
    setShowModal,
    isDeleting,
    isLoading,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-x-3'}>
                <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                <Filter
                    show={modal?.filter}
                    setShow={(value) => setShowModal({ filter: value })}
                    options={FILTER_GIFT}
                    values={queryFilter}
                    onSubmit={(value) => onFilter(value)}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_FLASH_SALE.name}
                columns={TABLE_FLASH_SALE.column}
                data={dataList?.result}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={(val) => onClickItemHandler(val)}
                loading={isLoading}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure Delete This?'}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
        </div>
    )
}
